<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row margin-top-4 margin-bottom-4">
          <div class="col-xl-4 col-12 col-sm-6 col-md-6 col-lg-4">
            <div class="w-100 d-inline-block bg-white padding-2 rounded-4 contact-us-box">
              <div class="w-100 d-inline-block border-bottom padding-bottom-2">
                <div class="row">
                  <div class="col-2">
                    <div class="w-100 d-inline-block address-box text-center">
                      <span class="d-inline-block bg-introduction rounded-5">
                         <img v-lazy="require('@/assets/images/address-icon.svg')" alt="picture">
                      </span>
                    </div>
                  </div>
                  <div class="col-10">
                    <div class="w-100 d-inline-block margin-top-2">
                      <p class="mb-0 text-size-14 text-black text-uppercase inter-bold-family text-full-13">
                        ADDRESS
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-inline-block 
              address-contact-section">
                <p class="mb-0 text-size-14 text-black inter-regular-family text-uppercase float-xs-start w-xs-30 text-full-13">
                  DUBAI
                </p>
                <p class="mb-0 text-size-14 text-black inter-regular-family float-xs-end w-xs-70 text-full-13">
                  Timing: 9:00 Am - 10:00 Pm
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-12 mt-xl-0 mt-3 col-sm-6 col-md-6 col-lg-4 mt-md-0">
            <div class="w-100 d-inline-block bg-white padding-2 rounded-4 contact-us-box">
              <div class="w-100 d-inline-block border-bottom padding-bottom-2">
                <div class="row">
                  <div class="col-2">
                    <div class="w-100 d-inline-block address-box text-center">
                      <span class="d-inline-block bg-introduction rounded-5">
                        <img v-lazy="require('@/assets/images/phone-contact-icon.svg')" alt="picture">
                      </span>
                    </div>
                  </div>
                  <div class="col-10">
                    <div class="w-100 d-inline-block margin-top-2">
                      <p class="mb-0 text-size-14 text-black text-uppercase inter-bold-family text-full-13">
                        Phone
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-inline-block 
              mt-xl-2 mt-3">
                <p class="mb-0 text-size-14 text-black inter-regular-family text-uppercase float-xs-start w-xs-45 text-full-13">
                  +971 5228 09076
                </p>
                <p class="mb-0 text-size-14 text-black inter-regular-family float-xs-end w-xs-45 text-full-13">
                  +971 5228 09076
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-12 mt-xl-0 mt-3 col-sm-6 col-md-6 col-lg-4 mt-md-3 mt-lg-0">
            <div class="w-100 d-inline-block bg-white padding-2 rounded-4 contact-us-box">
              <div class="w-100 d-inline-block border-bottom padding-bottom-2">
                <div class="row">
                  <div class="col-2">
                    <div class="w-100 d-inline-block address-box email-box text-center">
                      <span class="d-inline-block bg-introduction rounded-5">
                        <img v-lazy="require('@/assets/images/email-contact-icon.svg')" alt="picture">
                      </span>
                    </div>
                  </div>
                  <div class="col-10">
                    <div class="w-100 d-inline-block margin-top-2">
                      <p class="mb-0 text-size-14 text-black text-uppercase inter-bold-family text-full-13">
                        Email
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-inline-block 
              margin-top-3">
                <p class="mb-0 text-size-14 text-black inter-regular-family text-uppercase text-full-13">
                  dubaipetsgroomer@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 d-inline-block bg-white 
        rounded-4">
          <div class="row">
            <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
              <div class="w-100 d-inline-block contact-dog-image">
                <img class="rounded-4 w-100" v-lazy="require('@/assets/images/pet-grooming-grooming-services-pet-grooming-prices.webp')" alt="pet grooming, grooming services, pet grooming prices">
              </div>
            </div>
            <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
              <div class="w-100 d-inline-block padding-3">
                <div class="w-100 d-inline-block margin-top-3">
                  <h1 class="text-black fw-bold text-full-24 filson-black-family margin-bottom-3 w-80 w-xs-100 w-sm-100 w-md-100 w-ipad-100 text-xs-size-20 text-size-24">
                    We Are Always Available For You & Your Pets
                  </h1>
                </div>
                <form @submit.prevent="submitForm">
                <div class="w-85 d-inline-block w-xs-100 w-sm-100 w-md-100 w-ipad-100 input-contact margin-bottom-3">
                  <input
                    class="w-100 bg-introduction text-size-16 h-40 border text-full-13"
                    type="text"
                    placeholder="Name"
                    v-model="form.name"
                    required
                  />
                </div>
                <div class="w-85 d-inline-block margin-bottom-3 w-xs-100 w-sm-100 w-md-100 w-ipad-100 input-contact">
                  <input
                    class="w-100 bg-introduction text-size-16 h-40 border text-full-13"
                    type="email"
                    placeholder="Email"
                    v-model="form.email"
                    required
                  />
                </div>
                <div class="w-85 d-inline-block margin-bottom-3 w-xs-100 w-sm-100 w-md-100 w-ipad-100 input-contact">
                  <input
                    class="w-100 bg-introduction text-size-16 h-40 border text-full-13"
                    type="number"
                    placeholder="Phone Number"
                    v-model="form.phone"
                    required
                  />
                </div>
                <div class="w-85 d-inline-block select-textarea w-xs-100 w-sm-100 w-md-100 w-ipad-100">
                  <textarea
                    class="form-control bg-introduction contact-textarea text-full-13 text-size-16"
                    id="Textarea"
                    rows="3"
                    placeholder="How Can We Help"
                    v-model="form.message"
                  ></textarea>
                </div>
                <div class="w-100 d-inline-block margin-top-3">
                  <button
                    type="submit"
                    class="text-size-14 text-white d-inline-block bg-green border-green rounded-5 inter-semi-bold text-full-13 send-btn w-xs-100 text-xs-center"
                  >
                    SEND
                  </button>
                </div>
              </form>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
              <div class="w-100 d-inline-block 
              contact-map">
                <iframe class="rounded-4" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d57778.84901106059!2d55.16265404796492!3d25.065700842325347!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f434e8c6a9c8b%3A0xe5f610c76341e9ac!2sDubai!5e0!3m2!1sen!2sae!4v1697627865337!5m2!1sen!2sae" style="border:0;" allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade">
              </iframe>
              </div>
            </div>
          </div>
          <div class="w-100 d-inline-block bg-introduction margin-top-3">
      <div class="container autoContent">
        <div class="row margin-top-2 margin-bottom-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
              <li class="float-start margin-right-2">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                  <i class="fa fa-home nav-color" aria-hidden="true"></i>
                  Home /
                </a>
              </li>
              <li class="float-start">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                  Services
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "contactBannerComponent",
    data() {
      return {
        form: {
          name: '',
          email: '',
          phone: '',
          message: '',
        },
      };
    },
    methods: {
      async submitForm() {
        try {
          const response = await this.$axios.post('/store-contact-us', {
            website_name: this.$websiteName,
            formData: this.form,
          });
          console.log('response data', response);
          if(response.data.status == 'success'){
            this.$toast.success('Your message has been sent!');
          }
          this.resetForm();
        } catch (error) {
          console.error('Submission error:', error);
          this.$toast.error('Something went wrong. Please try again.');
          // alert('Something went wrong. Please try again.');
        }
      },
      resetForm() {
        this.form = {
          name: '',
          email: '',
          phone: '',
          message: '',
        };
      },
    },
  };
</script>

<style scoped></style>
